var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472 128h-10.39a72 72 0 1 0-107.22 0H256V48a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v80h-8V16a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v112h-8V72a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v56H40a32.036 32.036 0 0 0-32 32v240a32.036 32.036 0 0 0 32 32h164.9l-10.67 32H168a8 8 0 0 0-8 8v16H80a8 8 0 0 0 0 16h352a8 8 0 0 0 0-16h-80v-16a8 8 0 0 0-8-8h-26.23l-10.67-32H472a32.036 32.036 0 0 0 32-32V160a32.036 32.036 0 0 0-32-32ZM416 24.58A56.11 56.11 0 0 1 463.42 72H416ZM411.31 88h52.11a55.962 55.962 0 0 1-88.94 36.83ZM352 80a56.086 56.086 0 0 1 48-55.42v52.11l-36.83 36.83A55.708 55.708 0 0 1 352 80ZM224 56h16v152h-16Zm-24 88h8v64h-8ZM168 24h16v184h-16Zm-24 120h8v64h-8Zm-32-64h16v128h-16Zm224 400v8H176v-8Zm-124.9-16 10.67-32h68.46l10.67 32ZM488 400a16.021 16.021 0 0 1-16 16H40a16.021 16.021 0 0 1-16-16v-16h464Zm0-32H24V160a16.021 16.021 0 0 1 16-16h56v64h-8v-48a8 8 0 0 0-8-8H48a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h256a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v48h-8v-64h119.08a71.733 71.733 0 0 0 65.84 0H472a16.021 16.021 0 0 1 16 16ZM72 168v40H56v-40Zm208 40v-40h16v40Z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 392H48a8 8 0 0 0 0 16h48a8 8 0 0 0 0-16ZM128 392h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16ZM344 208a7.974 7.974 0 0 0 5.657-2.343L379.313 176H448a8 8 0 0 0 0-16h-72a8 8 0 0 0-5.657 2.343l-32 32A8 8 0 0 0 344 208ZM448 296a24 24 0 0 0-20.75 11.97l-83.75-48.86a24 24 0 0 0-47.11.6l-84.28 63.21a23.979 23.979 0 0 0-41.48 2.18l-83.3-34.71a24.01 24.01 0 1 0-1.96 16.51l83.3 34.71a23.995 23.995 0 0 0 46.94-1.32l84.28-63.21a23.973 23.973 0 0 0 40.86-1.05l83.75 48.86A24 24 0 1 0 448 296Zm-376 .04a8.02 8.02 0 1 1 0-.04ZM192 344a8.011 8.011 0 0 1-8-8v-.04a8 8 0 1 1 8 8.04Zm128-72a8 8 0 1 1 8-8 8.011 8.011 0 0 1-8 8Zm128 56a8 8 0 1 1 8-8 8.011 8.011 0 0 1-8 8Z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 344h-56a8 8 0 0 0 0 16h56a8 8 0 0 0 0-16ZM384 320h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16ZM48 248h88a8 8 0 0 0 0-16H48a8 8 0 0 0 0 16ZM160 248h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16Z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalysis);
export default __webpack_public_path__ + "static/media/DataAnalysis.e0cd3795886727ec65774d2c685eec03.svg";
export { ForwardRef as ReactComponent };